function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
export var HttpError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(HttpError, Error1);
    var _super = _create_super(HttpError);
    function HttpError(props) {
        _class_call_check(this, HttpError);
        var _this;
        _this = _super.call(this, props.message);
        _define_property(_assert_this_initialized(_this), "code", void 0);
        _define_property(_assert_this_initialized(_this), "headers", void 0);
        _define_property(_assert_this_initialized(_this), "message", void 0);
        _define_property(_assert_this_initialized(_this), "meta", void 0);
        _define_property(_assert_this_initialized(_this), "method", void 0);
        _define_property(_assert_this_initialized(_this), "name", void 0);
        _define_property(_assert_this_initialized(_this), "status", void 0);
        _define_property(_assert_this_initialized(_this), "traceId", void 0);
        _define_property(_assert_this_initialized(_this), "url", void 0);
        _this.code = props.code;
        _this.headers = props.headers;
        _this.name = props.name;
        _this.message = props.message;
        _this.status = props.status;
        _this.traceId = props.traceId;
        _this.meta = props.meta;
        _this.method = props.method;
        _this.url = props.url;
        return _this;
    }
    return HttpError;
}(_wrap_native_super(Error));
export var HttpClientError = /*#__PURE__*/ function(HttpError) {
    "use strict";
    _inherits(HttpClientError, HttpError);
    var _super = _create_super(HttpClientError);
    function HttpClientError(props) {
        _class_call_check(this, HttpClientError);
        return _super.call(this, _object_spread_props(_object_spread({}, props), {
            message: props === null || props === void 0 ? void 0 : props.message,
            name: 'HttpClientError',
            status: props === null || props === void 0 ? void 0 : props.status
        }));
    }
    return HttpClientError;
}(HttpError);
export function getErrorCode(body, defaultCode) {
    var _body_errors_, _body_errors;
    var _body_errors__code, _ref, _ref1;
    return (_ref1 = (_ref = (_body_errors__code = (_body_errors = body.errors) === null || _body_errors === void 0 ? void 0 : (_body_errors_ = _body_errors[0]) === null || _body_errors_ === void 0 ? void 0 : _body_errors_.code) !== null && _body_errors__code !== void 0 ? _body_errors__code : body.code) !== null && _ref !== void 0 ? _ref : defaultCode) !== null && _ref1 !== void 0 ? _ref1 : 'UNKNOWN_EXCEPTION';
}

//# sourceMappingURL=errorCodes.js.map